module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-up-24f154d3.svg";